module.exports = __webpack_public_path__ + "static/media/square-add.d07ba158.svg";